import type { FaireProductEntity } from "../../entity_types/product";

export const p_6y246qhmj6: FaireProductEntity = {
  token: "p_6y246qhmj6",
  type: "product",
  name: "DIY Elderberry Syrup Kit",
  brandToken: "b_3bx0gt904o",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/02a249030a957bb124c67b90aa7fa31761b86af950fc15c46f87d5aae8341c61.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3b12fc7214f69ebbfeaa2c50bb0ba076cca937a884cd24c3ea3cccdaa9f47bc6.png",
    "https://cdn.faire.com/fastly/d3c11d00d87ef5c342e19e612da5b2dfb3e1224d581ebb5cad67e1504ff8edc4.png",
    "https://cdn.faire.com/fastly/6af83c17284f1b0262d8fcbed7782d7f9722bc8faefa4fee94976f033252ba58.png",
    "https://cdn.faire.com/fastly/6cb32758f72fb9187e3e6d49f954bf65aad4ee4bc8eb95ae215ec83ef13a0ac8.png",
    "https://cdn.faire.com/fastly/147878f430ffd7225087fc8d9a2a503ceea862beb4b71ebe4d0a5675aced23cf.png",
  ],
  priceDollars: 4,
  description:
    "\nOur Elderberry DIY Kits are made with a powerful blend of immune boosting herbs & spices to help fight sickness and ward off bugs and viruses that are going around. The syrup can be taken daily, morning and evening, or every 2 hours when working to give your system an extra boost. \n\nIncluded are these incredible organic herbs & spices:\n\n ✨ Elderberries \n\n✨ Ceylon Cinnamon\n\n✨ Turmeric Root\n\n✨ Cloves \n\n✨ Rosehips\n\n✨ Astragalus Root\n\nOur 1oz mini kit makes approximately 3/4- 1 cup of syrup. \n\nThe 4oz full-sized kit makes approximately 4 cups (1 pint) of syrup.\n\nTo make your 1oz mini kit, simply add it to one cup of water and bring to a boil. Simmer for 25 minutes, strain and add up to 1/2 cup of honey or sweetener of choice. \n\nTo make your 4oz kit, simply add it to 4 cups of water and bring to a boil. Simmer for 25 minutes, strain and add up to 2 cups honey or sweetener of choice. \n\n* Store syrup in an airtight glass jar in the refrigerator for up to one month. \n",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:43.902Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
